import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useLocCities = (state) => useQuery({ queryKey: ['cities', state], queryFn: async () => {
    const callback = await API.get(`/common/loc/states/${state}/cities`)
    return callback?.data
}})

export default useLocCities